
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'result-info',
  props: { label: { type: String, required: true } },
});
